import {randomId} from "../../modules/utils";

const state = {
  alerts: []
};

const getters = {
  getAlerts(state) {
    return state.alerts;
  }
};

const mutations = {
  noAlert(state, data) {
    state.alerts = [...state.alerts, data];
  },
  removeAlert(state, id) {
    state.alerts = state.alerts.filter(x => x.id !== id);
  },
  removeAllAlerts(state) {
    state.alerts = [];
  }
};

const actions = {
  notify({commit}, {message, variant = "success", duration = 5000, stack = true}) {
    if (!stack) {
      commit("removeAllAlerts");
    }
    const id = randomId();
    commit("noAlert", {message, variant, duration, id});

    setTimeout(() => {
      commit("removeAlert", id);
    }, duration);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};